export default "__VITE_ASSET__DrVyKLVv__"